import { Box } from '@cof/plastic-components';
import { css, styled } from 'styled-components';

export const StyledFormWrapper = styled(Box)`
    ${({ theme }: any) => css`
        ${theme.components.StyledFormWrapper}
        padding-bottom: ${theme.space.lg};
        position: relative;
        z-index: 3;
        background: ${theme.colors.capitalOne.blue750};
        ${theme.components.StyledFormWrapper}
    `}
`;
StyledFormWrapper.displayName = 'FormWrapper';
